import { Button } from "react-bootstrap";
import { RiEdit2Fill } from "react-icons/ri";
import { BsTrash } from "react-icons/bs";
import { NavLink } from "react-router-dom";
import { Tooltip } from "antd";

export const refundInitFilterInput = {
  searchName: "",
  transactionStartDate: null,
  transactionEndDate: null,
  page: 1,
  pageSize: 10,
  sortingField: null,
  sortingOrder: null,
};

export const addRefundInitData = {
  gadaiCode: "",
  reward: "",
  remainingMoney: "",
  description: "",
  bankName: "",
  accountNumber: "",
  accountName: "",
  transferProof: "",
  approvalProof: "",
};

export const renderRefundColumns = (
  handleEditButtonClick = null,
  handleDeleteButtonClick = null,
  renderColumn = true
) => {
  return [
    {
      dataIndex: "dateTime",
      key: "dateTime",
      backend_key: "date_time",
      title: "Tanggal & Waktu",
      sorter: true,
      width: 70,
    },
    {
      dataIndex: "pawnNumber",
      key: "pawnNumber",
      title: "No. Surat Bukti Gadai",
      width: 80,
    },
    {
      dataIndex: "receiptNumber",
      key: "receiptNumber",
      title: "No. Kwitansi",
      width: 100,
    },
    {
      dataIndex: "gadaiCode",
      key: "gadaiCode",
      backend_key: "gadai_proof",
      title: "Kode Gadai",
      width: 100,
      sorter: true,
    },
    {
      dataIndex: "customerName",
      key: "customerName",
      backend_key: "customer_name",
      title: "Nama Nasabah",
      width: "10%",
      sorter: true,
    },
    {
      dataIndex: "reward",
      key: "reward",
      title: "Reward",
      width: 100,
    },
    {
      dataIndex: "remainingMoney",
      key: "remainingMoney",
      title: "Sisa Uang Lelang",
      width: 100,
    },
    {
      dataIndex: "accountName",
      key: "accountName",
      backend_key: "bank_account_name",
      title: "Nama Rekening",
      width: "10%",
      sorter: true,
    },
    {
      dataIndex: "bankOrAccountNumber",
      key: "bankOrAccountNumber",
      title: "Bank/No. Rekening",
      width: "12%",
    },
    {
      dataIndex: "description",
      key: "description",
      title: "Keterangan",
      width: "12%",
    },
    ...(renderColumn
      ? [
          {
            dataIndex: "transferProof",
            key: "transferProof",
            title: "Bukti Transfer",
            width: "7%",
          },
          {
            dataIndex: "approvalProof",
            key: "approvalProof",
            title: "Bukti Persetujuan",
            width: "7%",
          },
          {
            dataIndex: "action",
            key: "action",
            title: "Aksi",
            width: "5%",
            render: (_, record) => (
              <div className="d-flex" style={{ gap: "10px" }}>
                <Button
                  className="btn-icon icon-edit"
                  onClick={() => handleEditButtonClick(record)}
                >
                  <RiEdit2Fill size={24} />
                </Button>
                <Button
                  className="btn-icon icon-delete"
                  onClick={() =>
                    handleDeleteButtonClick(record.gadaiID, record.gadaiCode)
                  }
                >
                  <BsTrash size={24} />
                </Button>
              </div>
            ),
          },
        ]
      : []),
  ];
};

export const renderRefundRequestColumns = (handleOpenAddDialog = null) => {
  return [
    {
      dataIndex: "dateTime",
      key: "dateTime",
      backend_key: "created_at",
      title: "Tanggal & Waktu",
      sorter: true,
      width: 70,
    },
    {
      dataIndex: "pawnNumber",
      key: "pawnNumber",
      title: "No. Surat Bukti Gadai",
      width: 80,
    },
    {
      dataIndex: "receiptNumber",
      key: "receiptNumber",
      title: "No. Kwitansi",
      width: 100,
    },
    {
      dataIndex: "customerName",
      key: "customerName",
      backend_key: "ktp_name",
      title: "Nama Nasabah",
      width: 200,
      sorter: true,
    },
    {
      dataIndex: "phone",
      key: "phone",
      title: "No. Telepon",
      width: 100,
    },
    {
      dataIndex: "remainingMoney",
      key: "remainingMoney",
      title: "Sisa Uang Lelang",
      width: 100,
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "5%",
      render: (_, record) => (
        <div className="d-flex" style={{ gap: "10px" }}>
          <Button
            variant="primary"
            className="btn-action btn-detail"
            onClick={() => handleOpenAddDialog(record)}
          >
            Proses
          </Button>
        </div>
      ),
    },
  ];
};

export const renderRefundExpiredColumns = (handleViewDetail = null) => {
  return [
    {
      dataIndex: "dateTime",
      key: "dateTime",
      backend_key: "created_at",
      title: "Tanggal & Waktu",
      sorter: true,
      width: 70,
    },
    {
      dataIndex: "pawnNumber",
      key: "pawnNumber",
      title: "No. Surat Bukti Gadai",
      width: 80,
    },
    {
      dataIndex: "receiptNumber",
      key: "receiptNumber",
      title: "No. Kwitansi",
      width: 100,
    },

    {
      dataIndex: "gadaiCode",
      key: "gadaiCode",
      title: "Kode Gadai",
      width: 100,
    },
    {
      dataIndex: "customerName",
      key: "customerName",
      backend_key: "customer_name",
      title: "Nama Nasabah",
      width: 200,
      sorter: true,
    },
    {
      dataIndex: "remainingMoney",
      key: "remainingMoney",
      title: "Sisa Uang Lelang",
      width: 100,
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "5%",
      render: (_, record) => (
        <div className="d-flex" style={{ gap: "10px" }}>
          <Button
            onClick={() => handleViewDetail(record)}
            variant="outline-secondary"
            className="btn-action btn-default"
            style={{ width: "100%" }}
          >
            Detail
          </Button>
        </div>
      ),
    },
  ];
};
